<template>
  <dv-capsule-chart :config="config" style="width:300px;height:200px" />
</template>

<script>
export default {
  name: "ZGRanking1",
  data() {
    return {
      config: {},
      //折线数据

    }
  },
  methods:{

  },

  created() {
    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };
    this.$api.zga_area_summary(data).then(res=>
    {
      this.config = {
        data: res,
        colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
        unit: '元',
        showValue: true
      }
    })
  },
  watch: {

  }
}
</script>

<style scoped>

</style>